import React from 'react';
export const withStyles = (options = {}, ...rest) => WrappedComponent => {

    return (
      <WrappedComponent
        {...rest}
      />
    )
}

